import MVT from 'ol/format/MVT';
import BaseLayer from 'ol/layer/Base';
import { Component, computed, effect, inject, Signal } from '@angular/core';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import { AppService } from '../../../../services/app.service';
import { MapService } from '../../../../services/map.service';
import { BaseUILayer } from '../../../classes/layers/base-ui-layer';
import { LayerHeaderComponent } from '../../layer-header/layer-header.component';

@Component({
  selector: 'tgrid-county-ranking-layer',
  imports: [
    LayerHeaderComponent,
  ],
  templateUrl: './county-ranking-layer.component.html',
  standalone: true,
  styleUrl: './county-ranking-layer.component.scss',
})
export class CountyRankingLayerComponent extends BaseUILayer<BaseLayer> {
  private appService = inject(AppService);

  private sourceUrl: Signal<string> = computed(() => {
    const abbreviations = this.appService.selectedStates().map(s => s.abbreviation).join(',');
    const url = this.mapLayer().serviceUrl;

    return `${url}?states=${abbreviations}`;
  });

  protected colors: { category: string, color: string; }[] = [
    { category: 'Q5', color: '#1034A6' },
    { category: 'Q4', color: '#412F88' },
    { category: 'Q3', color: '#722B6A' },
    { category: 'Q2', color: '#A2264B' },
    { category: 'Q1', color: '#D3212D' },
  ];

  constructor() {
    super();

    effect(() => {
      // I had to add this because the effect does not pick up the url change if it is inside the if.
      const newUrl = this.sourceUrl();
      if (this.checked) {
        const source = (this.mapLayer().renderedLayer as VectorTileLayer).getSource();
        source?.setUrl(newUrl);
      }
    });

  }

  override toggleLayer(checked: boolean): void {
    this.checked = checked;
    if (this.checked) {
      if (this.mapLayer().renderedLayer) {
        const source = (this.mapLayer().renderedLayer as VectorTileLayer).getSource();
        source?.setUrl(this.sourceUrl());
      } else {
        this.mapLayer().renderedLayer = new VectorTileLayer({
          properties: {
            type: this.mapLayer().serviceType,
            name: this.mapLayer().displayName,
            popoverFunction: this.mapLayer().createPopover.bind(this.mapLayer()),
          },
          source: new VectorTileSource({
            format: new MVT(),
            url: this.sourceUrl(),
            attributions: this.mapLayer().buildAttribution(),
          }),
          style: (feature) => {
            const properties = feature.getProperties();
            const key: string = properties['quartile'];


            return new Style({
              fill: new Fill({
                color: this.colors.find(c => c.category === key)?.color || '#444444',
              }),
              stroke: new Stroke({
                color: '#000',
                width: 1,
              }),
            });
          },
        });
      }

      MapService.getMapRef()!.addLayer(this.mapLayer().renderedLayer);
      this.changeOpacity(this.opacity);

    } else {
      MapService.getMapRef()!.removeLayer(this.mapLayer().renderedLayer);
    }
  }


  override changeOpacity(value: number) {
    this.opacity = value;
    (this.mapLayer().renderedLayer as VectorTileLayer).setOpacity(value / 100);
  }

  override onDestroy(): void {
  }

}
